import actions from './actionTypes';
import * as api from '../services/api';
import {
  addToCanvas,
  deleteElement,
  showNonEditableAlert,
  setMessageDialogParams,
  setSidebarVisibility,
  isVisualizeModeActive,
  placeableIsUpdated
} from './fabricCanvasActions';
import { getOneLevelFolders, createResponseObject } from './modalActions';
import {
  fetchPremiumContents,
  fetchDreamstimeContents,
  fetchUnsplashContents,
  fetchGettyImageContents,
  fetchIStockContents,
  fetchAdobeStockContents,
  fetchHPMosaicContents,
  randomizeHPMosaicContents,
  fetchHostedContents
} from './sideBarActionHelpers';
import {
  searchForPatterns,
  triggerRedrawAfterDataFetch,
  handleBottomBarClick
} from './sideBarActionHelpers';
import {
  searchForUnsplash,
  searchForGettyImage,
  searchForIStock,
  searchForAdobeStock
} from './sideBarActionHelpers';
import { searchForDreamstime, setSearchContents } from './sideBarActionHelpers';
import { getInspirations } from './sideBarActionHelpers';
import { getNextInspirationsList } from './sideBarActionHelpers';
import { setLoadingState, addSolidColors } from './fabricCanvasActions';
import {
  convertToDictFromColorArray,
  redrawScene
} from './fabricCanvasActionHelpers';
import * as Constants from '../utilities/constants/Constants';
import { Icons } from '../utilities';
import { string } from '../localization/Localization';
import {
  getOnlyInstagramPlacings,
  shouldSelectTabFromUrl,
  isPremiumTheme,
  isSignageSuiteProduct,
  isMaskApp,
  isHostedContent,
  isNonEditableInspiration,
  checkIfMaskAppBeforeProductSelection
} from '../utilities/HelperFunctions/HelperFunctions';
import {
  isOmenLaptopOfTurkeyAccount,
  isWallcoveringApp
} from '../utilities/HelperFunctions/SignageHelperFunctions';
import {
  GAForTextTabClick,
  tabChangeGA
} from '../utilities/GAHelpers/GAHelpers';
import { setViewMode } from './fabricCanvasActions';
import {
  getActiveTabName,
  startTimer
} from '../utilities/TimerUtils/SidebarTimerUtils';
import { getPlacings } from './ProjectData/Project';
import { checkIfCanvasApp } from './homeActions';

export const checkOmenLaptopOfTurkeyAccount = () => dispatch =>
  dispatch(isOmenLaptopOfTurkeyAccount());

export const loadInspirations = (perPage, category, callback) => dispatch => {
  dispatch({
    type: actions.SET_INSPIRATION_OFFSET,
    payload: {
      offset: 0
    }
  });
  const currentList = { portraitInspirations: [], landscapeInspirations: [] };
  dispatch(getInspirations(0, perPage, category.value, callback, currentList));
  dispatch({
    type: actions.SET_INSPIRATION_FILTER,
    payload: {
      category: category.value
    }
  });
};

export const setInspirationOffset = (offset, moreInspirationsCheck) => (
  dispatch,
  getState
) => {
  dispatch({
    type: actions.SET_INSPIRATION_OFFSET,
    payload: {
      offset
    }
  });
  dispatch(setShowLoading(true));
  const { category } = getState().sideBar.inspirations;
  dispatch(
    getNextInspirationsList(offset, 10, category, moreInspirationsCheck)
  );
};

export const getFirstTheme = () => (dispatch, getState) => {
  const { themesArray, scenesData } = getState().modal;
  let firstTheme = null;
  if (themesArray) {
    const allScenesData = themesArray.scenesData;
    for (let i = 0; i < scenesData.length; i++) {
      const theme = scenesData[i];
      if (!isPremiumTheme(theme)) {
        firstTheme = dispatch(
          checkHasContentsRecursively(theme, allScenesData)
        );
        break;
      }
    }
  }

  return firstTheme;
};

export const checkHasContentsRecursively = (
  theme,
  allScenesData
) => dispatch => {
  const themeDetails = allScenesData.filter(t => t.id === theme.id)[0];
  let firstTheme = null;
  if (themeDetails.elements.length > 0) {
    firstTheme = themeDetails;
  } else if (
    Object.prototype.hasOwnProperty.call(theme, 'themes') &&
    theme.themes.length > 0
  ) {
    const subThemes = theme.themes;
    for (let i = 0; i < subThemes.length; i++) {
      const subTheme = subThemes[i];
      firstTheme = dispatch(
        checkHasContentsRecursively(subTheme, allScenesData)
      );
      if (firstTheme !== null) {
        break;
      }
    }
  }
  return firstTheme;
};

export const handleTabChange = tab => (dispatch, getState) => {
  if (tab !== getState().sideBar.activeSideBarTab) {
    dispatch(tabChangeGA());
    dispatch(changeSideBarTab(tab));
    dispatch(startTimer());
    dispatch(setTextTabGA(tab));
  }
};

export const setTextTabGA = tab => dispatch => {
  if (tab === Constants.TEXT_ELEMENT_TYPE) {
    dispatch(GAForTextTabClick());
  }
};

export const tabChangeEvent = dict => (dispatch, getState) => {
  const tabFromUrl = shouldSelectTabFromUrl();
  let tab = 0;
  if (tabFromUrl) {
    for (let i = 0; i < dict.length; i++) {
      if (dict[i].id == tabFromUrl) {
        tab = i;
        break;
      }
    }
  }
  if (
    getState().sideBar.tabName === null ||
    dict[tab].tab_id !== getState().sideBar.tabName
  ) {
    const tabName = getActiveTabName(dict[tab].tab_id);
    dispatch(setTextTabGA(dict[tab].tab_id));
    dispatch(setTabUsageDuration(getState().sideBar.tabTime, tabName));
  }

  dispatch(changeSideBarTab(dict[tab].tab_id));
};

export const changeSideBarTab = activeSideBarTab => (dispatch, getState) => {
  if (
    activeSideBarTab == Constants.UPLOAD_TAB_KEY &&
    dispatch(isNonEditableInspiration())
  ) {
    dispatch(showNonEditableAlert());
    return;
  }

  const isSignage = isSignageSuiteProduct();
  const isCanvas = dispatch(checkIfCanvasApp());
  if (isSignage || isCanvas) {
    if (
      getState().sideBar.activeSideBarTab !== null &&
      (activeSideBarTab === Constants.PHOTO_TAB_KEY ||
        activeSideBarTab === Constants.ELEMENT_TAB_KEY ||
        activeSideBarTab === Constants.TEXT_ELEMENT_TYPE) &&
      getState().fabricCanvas.viewType === Constants.THREE_D_TYPE
    ) {
      dispatch(setViewMode(Constants.TWO_D_TYPE));
    }
  }
  if (isCanvas) {
    if (
      getState().sideBar.activeSideBarTab !== null &&
      activeSideBarTab === Constants.MY_ROOM_TAB_KEY &&
      getState().fabricCanvas.viewType === Constants.TWO_D_TYPE
    ) {
      dispatch(setViewMode(Constants.THREE_D_TYPE));
    }
  }

  dispatch({
    type: actions.SET_FOLDER_LIST_ELEMENTS,
    payload: { folderListElements: null }
  });
  dispatch({ type: actions.CHANGE_SIDEBAR_TAB, payload: { activeSideBarTab } });
  dispatch(setShouldLoadMoreContents(false));
  dispatch(setSearchTags(null, 'clear', 0));
};

export const changeMaterialTab = activeMaterailTab => dispatch => {
  dispatch({
    type: actions.CHANGE_MATERIAL_TAB,
    payload: {
      activeMaterailTab
    }
  });
};

export const showPremiumTag = theme => {
  if (
    theme.name.search('iStock') !== -1 ||
    theme.name.search('Getty Images') !== -1 ||
    theme.name.search('Dreamstime') !== -1 ||
    theme.name.search('Pattern Design') !== -1 ||
    theme.name.search('Adobe Stock') !== -1 ||
    (Object.prototype.hasOwnProperty.call(theme, 'isPremium') &&
      theme.isPremium)
  ) {
    return true;
  }
  return false;
};

export const isInfoButtonReq = theme => {
  if (
    theme.name.search('iStock') !== -1 ||
    theme.name.search('Getty Images') !== -1 ||
    theme.name.search('Unsplash') !== -1 ||
    theme.name.search('Dreamstime') !== -1 ||
    theme.name.search('Pattern Design') !== -1 ||
    theme.name.search('Adobe Stock') !== -1 ||
    (Object.prototype.hasOwnProperty.call(theme, 'isPremium') &&
      theme.isPremium)
  ) {
    return true;
  }
  return false;
};

const createThumbnailDict = element => {
  let thumbnailDict = null;
  if (Object.prototype.hasOwnProperty.call(element, 'width')) {
    thumbnailDict = {
      path: element.thumbnailPath,
      aspectRatio: element.width / element.height
    };
  }
  return thumbnailDict;
};

export const getGroupThumbnails = (
  thumbnailList,
  parentTheme,
  data
) => dispatch => {
  parentTheme.elements.forEach(ele => {
    const thumbnailDetails = createThumbnailDict(ele);
    if (thumbnailDetails) thumbnailList.push(thumbnailDetails);
  });
  if (
    Object.prototype.hasOwnProperty.call(parentTheme, 'themes') &&
    parentTheme.themes.length > 0
  ) {
    const folderThemes = [];
    dispatch(getOneLevelFolders(parentTheme.themes, folderThemes, data, null));
    folderThemes.forEach(subTheme => {
      if (subTheme) {
        if (
          Object.prototype.hasOwnProperty.call(subTheme, 'themes') &&
          subTheme.themes.length > 0
        ) {
          dispatch(getGroupThumbnails(thumbnailList, subTheme, data));
        } else {
          subTheme.elements.forEach(subThemeElement => {
            const thumbnailDetails = createThumbnailDict(subThemeElement);
            if (thumbnailDetails) thumbnailList.push(thumbnailDetails);
          });
        }
      }
    });
  }
};

export function selectFourRandomImages(contentList) {
  const images = [];
  const randomIndexes = [];
  if (contentList.length >= 4) {
    for (let i = 0; i < 4; i++) {
      const randomNumber = getRndInteger(0, contentList.length - 1);
      if (randomIndexes.indexOf(randomNumber) === -1) {
        randomIndexes.push(randomNumber);
      }
    }

    let index = 0;
    while (randomIndexes.length < 4) {
      if (randomIndexes.indexOf(index) === -1) {
        randomIndexes.push(index);
      }
      index++;
    }

    // Random number shouldn't be repeating
    for (let j = 0; j < randomIndexes.length; j++) {
      images.push(contentList[randomIndexes[j]]);
    }
  } else if (contentList.length > 0) {
    images.push(contentList[0]);
  }

  return images;
}

function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

export const checkForContentsRecursively = (
  oneLevelThemes,
  allThemes
) => dispatch => {
  oneLevelThemes.forEach(theme => {
    if (/_pattern_design/.test(theme.internalName)) {
      theme.groupThumbnail = [
        {
          path: Icons.pattern_design_icon,
          aspectRatio: 1
        }
      ];
    } else if (/_vecteezy/.test(theme.internalName)) {
      theme.groupThumbnail = [
        {
          path: Icons.vecteezy_icon,
          aspectRatio: 1
        }
      ];
    } else if (/_unsplash/.test(theme.internalName)) {
      theme.groupThumbnail = [
        {
          path: Icons.unsplash_icon,
          aspectRatio: 1
        }
      ];
    } else if (/_dreamstime/.test(theme.internalName)) {
      theme.groupThumbnail = [
        {
          path: Icons.dreamstime_icon,
          aspectRatio: 1
        }
      ];
    } else if (/_getty_images/.test(theme.internalName)) {
      theme.groupThumbnail = [
        {
          path: Icons.gettty_Icon,
          aspectRatio: 1
        }
      ];
    } else if (/_istock/.test(theme.internalName)) {
      theme.groupThumbnail = [
        {
          path: Icons.istock_icon,
          aspectRatio: 1
        }
      ];
    } else if (/_adobe_stock/.test(theme.internalName)) {
      theme.groupThumbnail = [
        {
          path: Icons.adobe_stock_icon,
          aspectRatio: 1
        }
      ];
    } else if (
      /_hp_mosaic/.test(theme.internalName) ||
      theme.hostedContentThemeId
    ) {
      theme.groupThumbnail = [
        {
          path: theme.thumbnailPath,
          aspectRatio: 1
        }
      ];
    } else {
      const contenthumbnails = [];
      dispatch(getGroupThumbnails(contenthumbnails, theme, allThemes));

      const insideImages = selectFourRandomImages(contenthumbnails);
      theme.groupThumbnail = insideImages;
    }
  });
};

export const createThemeThumbnails = () => (dispatch, getState) => {
  const {
    themesArray,
    scenesData,
    elementsData,
    photosData
  } = getState().modal;

  dispatch(checkForContentsRecursively(scenesData, themesArray.scenesData));
  dispatch(checkForContentsRecursively(elementsData, themesArray.elementsData));
  dispatch(checkForContentsRecursively(photosData, themesArray.photosData));
};

export const getFolderListElements = theme => (dispatch, getState) => {
  dispatch({
    type: actions.SET_THEME,
    payload: {
      theme
    }
  });
  // disabling searched mode on first click for any themes folder
  dispatch(setSearchContents(false, null));

  if (isHostedContent(theme)) {
    dispatch(fetchHostedContents(theme));
  } else if (isPremiumTheme(theme)) {
    fetchPremiumContents(theme, dispatch, getState);
  } else {
    const { themesArray } = getState().modal;
    const activeTab = getState().sideBar.activeSideBarTab;
    const folderThemes = [];

    if (activeTab === Constants.BACKGROUND_TAB_KEY) {
      dispatch(
        getOneLevelFolders(
          theme.themes,
          folderThemes,
          themesArray.scenesData,
          Constants.SCENE_KEY
        )
      );
    } else if (activeTab === Constants.PHOTO_TAB_KEY) {
      dispatch(
        getOneLevelFolders(
          theme.themes,
          folderThemes,
          themesArray.photosData,
          Constants.PHOTO_KEY
        )
      );
    } else if (activeTab === Constants.ELEMENT_TAB_KEY) {
      dispatch(
        getOneLevelFolders(
          theme.themes,
          folderThemes,
          themesArray.elementsData,
          Constants.ELEMENT_KEY
        )
      );
    }
    theme.folders = folderThemes;

    dispatch({
      type: actions.SET_FOLDER_LIST_ELEMENTS,
      payload: {
        folderListElements: theme
      }
    });
  }
};

export const getParentFromFolder = (parentId, currentThemeId) => (
  dispatch,
  getState
) => {
  const { themesArray } = getState().modal;
  const activeTab = getState().sideBar.activeSideBarTab;
  let matchedThemes = [];
  let parentTheme = null;
  if (parentId === null || typeof parentId == 'undefined') {
    dispatch(changeSideBarTab(activeTab));
  } else {
    if (activeTab === Constants.BACKGROUND_TAB_KEY) {
      matchedThemes = themesArray.scenesData.filter(t => {
        const themeId = t.hostedContentThemeId ? t.hostedContentThemeId : t.id;
        return themeId === parentId;
      });
    } else if (activeTab === Constants.ELEMENT_TAB_KEY) {
      matchedThemes = themesArray.elementsData.filter(t => {
        const themeId = t.hostedContentThemeId ? t.hostedContentThemeId : t.id;
        return themeId === parentId;
      });
    } else if (activeTab === Constants.PHOTO_TAB_KEY) {
      matchedThemes = themesArray.photosData.filter(t => {
        const themeId = t.hostedContentThemeId ? t.hostedContentThemeId : t.id;
        return themeId === parentId;
      });
    }
    // Many themes might have same id. Hence 2nd step confirmation ie.. in those matched themes checking if its child theme and active
    // theme id is same.
    if (matchedThemes.length > 1) {
      [parentTheme] = matchedThemes.filter(
        matchedTheme =>
          matchedTheme.themes.filter(
            childTheme => childTheme.id == currentThemeId
          ).length > 0
      );
    } else if (matchedThemes.length > 0) {
      [parentTheme] = matchedThemes;
    }
    dispatch(getFolderListElements(parentTheme));
  }
  dispatch(setSearchTags('clear', 'clear', 0));
  dispatch(setShouldLoadMoreContents(false));
};

export const searchBarHandler = () => dispatch => {
  dispatch({
    type: actions.SET_OR_HIDE_SEARCH_BAR
  });
};

export const resetColorPickerSource = () => dispatch => {
  dispatch({
    type: actions.SET_COLOR_PICKER_SOURCE,
    payload: {
      value: null
    }
  });
};

export const patternColorPickerHandler = () => dispatch => {
  dispatch({
    type: actions.SET_COLOR_PICKER_SOURCE,
    payload: {
      value: Constants.PATTERN_COLOR
    }
  });
};

export const documentColorPickerHandler = source => dispatch => {
  dispatch({
    type: actions.SET_COLOR_PICKER_SOURCE,
    payload: {
      value: source
    }
  });
};

export const solidColorPickerHandler = () => dispatch => {
  dispatch({
    type: actions.SET_COLOR_PICKER_SOURCE,
    payload: {
      value: Constants.SOLID_COLOR
    }
  });
};

export const getRecolorArray = () => (dispatch, getState) => {
  dispatch(setLoadingState(''));
  const { activeObject } = getState().fabricCanvas;
  if (
    Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
    !activeObject.placing.placeable.svgColors &&
    !(
      activeObject.placing.placeable.colors &&
      activeObject.placing.placeable.colors.length > 0
    )
  ) {
    if (
      activeObject.placing.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE
    ) {
      api
        .getPatternDesignRecolorList(activeObject.placing.placeable.mediaId)
        .then(response => {
          activeObject.placing.placeable.colors = convertToDictFromColorArray(
            response.data.colors
          );
          dispatch(setLoadingState(null));
          dispatch(recolorPickerHandler());
        });
    }
  } else {
    dispatch(setLoadingState(null));
    dispatch(recolorPickerHandler());
  }
};

export const recolorPickerHandler = () => dispatch => {
  dispatch({
    type: actions.SET_COLOR_PICKER_SOURCE,
    payload: {
      value: Constants.RECOLOR
    }
  });
};

export const isSolidColorSupported = () => dispatch =>
  !isSignageSuiteProduct() || dispatch(checkIfMaskAppBeforeProductSelection());

export const documentColorPickerIsClicked = () => dispatch => {
  if (dispatch(isNonEditableInspiration())) {
    dispatch(showNonEditableAlert());
    return;
  }
  dispatch(documentColorPickerHandler(Constants.DOCUMENT_COLOR));
};

export const documentColorIsClicked = color => dispatch => {
  dispatch(documentColorPickerIsClicked());
  dispatch(setSolidBackgroundColor(color));
  dispatch(setDocumentColors(color));
};

export const solidColorIsClicked = color => dispatch => {
  dispatch(documentColorIsClicked(color));
};

export const setDocumentColors = inColors => (dispatch, getState) => {
  let colors = inColors;
  let palette = [];
  const documentColor = getState().sideBar.documentColors;
  if (Array.isArray(colors)) {
    // array-source is inspiration
    let docPalette = [];

    const inspColors = colors;
    docPalette = inspColors.concat(documentColor);
    dispatch(setSolidBackgroundColor(colors[0]));
    dispatch({
      type: actions.SET_DOCUMENT_COLORS,
      payload: {
        documentColors: docPalette
      }
    });
  } else {
    colors = colors.toLowerCase();
    if (colors.substr(0, 1) !== '#') {
      colors = `#${colors}`;
    }
    let isDuplicated = false;
    for (let i = 0; i < documentColor.length; i++) {
      if (documentColor[i].toLowerCase() === colors) {
        isDuplicated = true;
      }
    }

    if (!isDuplicated) {
      palette = documentColor.concat(colors);
      dispatch({
        type: actions.SET_DOCUMENT_COLORS,
        payload: {
          documentColors: palette
        }
      });
    }

    if (getState().sideBar.colorPickerSource == Constants.DOCUMENT_COLOR) {
      // source- solid colors

      if (!isDuplicated) {
        dispatch(setSolidBackgroundColor(colors));
      }

      dispatch(addSolidColors(colors));
    } else if (getState().sideBar.colorPickerSource == Constants.TEXT_COLOR) {
      // source- text colors
      dispatch(
        setTextColor({
          target: {
            value: colors
          }
        })
      );
    }
  }
};

export const shadowColorPickerHandler = () => dispatch => {
  dispatch({
    type: actions.SET_COLOR_PICKER_SOURCE,
    payload: {
      value: Constants.SHADOW_COLOR
    }
  });
};

export const setShouldLoadMoreContents = e => dispatch => {
  dispatch({
    type: actions.SET_SHOULD_LOAD_MORE_CONTENTS,
    payload: {
      shouldLoadMoreContents: e
    }
  });
};

export const setShowLoading = e => dispatch => {
  dispatch({
    type: actions.SHOW_LOADING_DIALOG,
    payload: {
      showLoading: e
    }
  });
};

export const setIsMaximumLimit = limit => dispatch => {
  dispatch({
    type: actions.IS_MAXIMUM_LIMIT,
    payload: {
      isMaximumLimit: limit
    }
  });
};

export const elementListTemplateUnMount = () => dispatch => {
  dispatch({
    type: actions.ELEMEMT_LIST_UNMOUNT
  });
};

const getTextPlaceable = () => (dispatch, getState) => {
  const { activeObject } = getState().fabricCanvas;
  if (
    activeObject &&
    Object.prototype.hasOwnProperty.call(activeObject, 'placing')
  ) {
    return activeObject.placing.placeable;
  }
  return null;
};

export const setCustomText = e => dispatch => {
  let buttonState;
  const textPlaceable = dispatch(getTextPlaceable());
  const placingValue = textPlaceable ? textPlaceable.text : '';
  if (
    e.target.value &&
    e.target.value.length > 0 &&
    e.target.value != placingValue
  ) {
    buttonState = true;
  } else {
    buttonState = false;
  }
  dispatch({
    type: actions.SET_CUSTOM_TEXT,
    payload: {
      customText: e.target.value,
      buttonState
    }
  });
};

export const setFontFamily = e => (dispatch, getState) => {
  const textPlaceable = dispatch(getTextPlaceable());
  const placingValue = textPlaceable ? textPlaceable.fontId : '';
  const { customText } = getState().sideBar.addText;
  const buttonState = customText && placingValue != e.id;

  dispatch({
    type: actions.SET_FONT_FAMILY,
    payload: {
      value: e.id,
      buttonState
    }
  });
};

export const setFontPath = e => (dispatch, getState) => {
  const textPlaceable = dispatch(getTextPlaceable());
  const placingValue = textPlaceable ? textPlaceable.textPath : '';
  const { customText } = getState().sideBar.addText;
  const buttonState = customText && placingValue != e.target.value;

  const { fontPath } = getState().sideBar.addText;
  Object.keys(fontPath).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(fontPath, key)) {
      fontPath[key].active = false;
      if (fontPath[key].name === e.target.value) {
        fontPath[key].active = true;
      }
    }
  });
  dispatch({
    type: actions.SET_FONT_PATH,
    payload: {
      fontPath,
      selectedFontPath: e.target.value,
      buttonState
    }
  });
};

export const setMaterial = (index, id) => (dispatch, getState) => {
  dispatch({
    type: actions.MATERIAL_INDEX,
    payload: {
      value: index
    }
  });
  getState().finalCheck.project.materialId = id;
};

export const setPatternSearchColor = colorInHex => (dispatch, getState) => {
  dispatch({
    type: actions.SET_COLOR_TO_SEARCH,
    payload: {
      value: colorInHex
    }
  });
  if (colorInHex !== 'none') {
    dispatch(
      setSearchTags(
        colorInHex.slice(1),
        getState().sideBar.searchTags.updatedText,
        0
      )
    );
  }
};

export const setColorToSearch = e => dispatch => {
  let color = e === null ? 'none' : e.target.value;
  if (typeof color === 'undefined') {
    color = 'none';
  }
  dispatch(setPatternSearchColor(color));
};

export const setTextColor = e => (dispatch, getState) => {
  let uiValue = e.target.value;
  const textPlaceable = dispatch(getTextPlaceable());
  let placingValue = textPlaceable ? textPlaceable.rgb : '';
  if (placingValue && placingValue.substr(0, 1) == '#') {
    placingValue = placingValue.substr(1);
  }
  if (uiValue && uiValue.substr(0, 1) == '#') uiValue = uiValue.substr(1);
  const { customText } = getState().sideBar.addText;
  const buttonState = customText && placingValue != uiValue;

  dispatch({
    type: actions.SET_TEXT_COLOR,
    payload: {
      value: e.target.value,
      buttonState
    }
  });
};

export const pickShadowColor = inColorInHex => (dispatch, getState) => {
  let colorInHex = inColorInHex;
  const textPlaceable = dispatch(getTextPlaceable());
  let placingValue = '';
  if (textPlaceable && textPlaceable.shadow) {
    placingValue = textPlaceable.rgb;
  }
  let uiValue = colorInHex;
  if (placingValue && placingValue.substr(0, 1) == '#') {
    placingValue = placingValue.substr(1);
  }
  if (uiValue && uiValue.substr(0, 1) == '#') uiValue = uiValue.substr(1);
  const { customText } = getState().sideBar.addText;

  const buttonState = customText && placingValue != uiValue;

  let placeholder = '';
  if (colorInHex === '') {
    colorInHex = 'none';
    placeholder = string.NO_SHADOW_KEY;
  }
  dispatch({
    type: actions.SET_SHADOW_COLOR,
    payload: {
      value: colorInHex,
      text: placeholder,
      buttonState
    }
  });
};

export const setShadowColor = e => dispatch => {
  const color = e.target.value;
  dispatch(pickShadowColor(color));
};

export const setCanvasFrameColor = val => (dispatch, getState) => {
  getState().finalCheck.project.canvasFrameColor = val;
};

export const setCanvasFrameType = val => (dispatch, getState) => {
  const oldCanvasFrameType = getState().finalCheck.project.canvasFrameType;
  getState().finalCheck.project.canvasFrameType = val;
  if (
    oldCanvasFrameType != val &&
    (oldCanvasFrameType == Constants.CANVAS_FRAME_TYPE_EXTEND ||
      val == Constants.CANVAS_FRAME_TYPE_EXTEND)
  ) {
    dispatch(redrawScene());
  }
};

export const setTextAlign = e => (dispatch, getState) => {
  const textPlaceable = dispatch(getTextPlaceable());
  const placingValue = textPlaceable ? textPlaceable.textAnchor : '';
  const { customText } = getState().sideBar.addText;

  const buttonState = customText && placingValue != e.value;

  dispatch({
    type: actions.SET_TEXT_ALIGNMENT,
    payload: {
      value: e.value,
      buttonState
    }
  });
};

export const resetTextTemplate = () => (dispatch, getState) => {
  const { addText } = getState().sideBar;
  const allKeys = Object.keys(addText.fontPath);
  allKeys.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(addText.fontPath, key)) {
      addText.fontPath[key].active = false;
      if (addText.fontPath[key].name === 'line') {
        addText.fontPath[key].active = true;
      }
    }
  });

  let defaultColor = '#000000';
  if (getState().modal.defaultColors.length > 1) {
    [defaultColor] = getState().modal.defaultColors;
  }

  let defaultFont = getState().modal.textFonts.filter(
    f => f.font_family === Constants.DEFAULT_FONT
  )[0];
  if (!defaultFont) {
    [defaultFont] = getState().modal.textFonts;
  }
  dispatch({
    type: actions.SET_TEXT_ATTRIBUTES,
    payload: {
      customText: null,
      buttonState: false,
      selectedFontPath: 'line',
      fontPath: addText.fontPath,
      fontId: defaultFont ? defaultFont.id : null,
      shadowColor: 'none',
      shadowText: string.NO_SHADOW_KEY,
      textColor: defaultColor,
      textAlign: 'middle'
    }
  });
};

export const submitAddText = (e, isDuplicate) => (dispatch, getState) => {
  const { addText } = getState().sideBar;

  if (e) {
    e.preventDefault();
    dispatch({
      type: actions.SET_LOADER_STATE,
      payload: {
        buttonState: false,
        loaderState: ''
      }
    });
  }
  dispatch(setDocumentColors(addText.textColor));

  if (e) e.target.reset();
  let shadowField = false;
  if (addText.shadowColor !== 'none') {
    shadowField = true;
  }
  let { textColor, shadowColor } = addText;
  if (textColor.substr(0, 1) == '#') textColor = textColor.substr(1);
  if (shadowColor.substr(0, 1) == '#') shadowColor = shadowColor.substr(1);

  const textData = {
    id: addText.id,
    type: Constants.TEXT_ELEMENT_TYPE,
    rgb: textColor,
    text: addText.customText,
    font_id: addText.fontId,
    text_path: addText.selectedFontPath,
    shadow: shadowField,
    shadow_color: shadowColor,
    text_anchor: addText.textAlign
  };
  const textPlaceble = createResponseObject(
    [textData],
    Constants.TEXT_ELEMENT_TYPE
  )[0];
  dispatch(addToCanvas(textPlaceble, { isDuplicate }));
};

export const objectIsSelected = selectedObject => dispatch => {
  if (
    selectedObject &&
    Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
    selectedObject.placing.placeableType === Constants.TEXT_ELEMENT_TYPE
  ) {
    const textColorValue = `#${selectedObject.placing.placeable.rgb}`;
    let shadowColor = 'none';
    let shadowText = string.NO_SHADOW_KEY;
    if (selectedObject.placing.placeable.shadow) {
      shadowColor = `#${selectedObject.placing.placeable.shadowColor}`;
      shadowText = '';
    }

    dispatch({
      type: actions.SET_TEXT_ALIGNMENT,
      payload: {
        value: selectedObject.placing.placeable.textAnchor
      }
    });
    dispatch({
      type: actions.SET_TEXT_ID,
      payload: {
        id: selectedObject.placing.placeableId
      }
    });
    dispatch(
      setCustomText({
        target: {
          value: selectedObject.placing.placeable.text
        }
      })
    );
    dispatch(
      setFontFamily({
        id: selectedObject.placing.placeable.fontId
      })
    );
    dispatch(
      setFontPath({
        target: {
          value: selectedObject.placing.placeable.textPath
        }
      })
    );
    dispatch(
      setTextColor({
        target: {
          value: textColorValue
        }
      })
    );
    dispatch({
      type: actions.SET_SHADOW_COLOR,
      payload: {
        value: shadowColor,
        text: shadowText
      }
    });
  } else {
    dispatch(resetTextTemplate());
  }
};

export const handleFileChange = e => (dispatch, getState) => {
  if (e.target.files && e.target.files[0]) {
    const uploadedFile = e.target.files[0];

    if (uploadedFile.size < 500000000) {
      if (
        uploadedFile.type === 'image/jpeg' ||
        uploadedFile.type === 'image/jpg' ||
        uploadedFile.type === 'image/svg' ||
        uploadedFile.type === 'image/png' ||
        uploadedFile.type === 'image/tiff' ||
        uploadedFile.type === 'image/pdf' ||
        uploadedFile.type === 'image/svg+xml' ||
        uploadedFile.type === 'application/pdf'
      ) {
        if (getState().sideBar.uploadErrorFlag != null) {
          dispatch(handleUploadErrorCase(null));
        }

        dispatch(handleUploadDialogueState(true));
        dispatch({
          type: actions.SET_UPLOAD_FILE,
          payload: {
            file: uploadedFile
          }
        });
      } else {
        dispatch(handleUploadErrorCase(Constants.UNSUPPORTED_FILE_TYPE_ERROR));
      }
    } else {
      dispatch(handleUploadErrorCase(Constants.UNSUPPORTED_FILE_SIZE_ERROR));
    }
  }
};

export const handleUploadErrorCase = errorType => (dispatch, getState) => {
  const { file } = getState().sideBar.upload;
  dispatch(setUploadErrorFlag(errorType));
  dispatch(handleUploadDialogueState(true));
  if (file != null) {
    dispatch({
      type: actions.SET_UPLOAD_FILE,
      payload: {
        file: null
      }
    });
  }
};

export const setUploadErrorFlag = state => dispatch => {
  dispatch({
    type: actions.SET_UPLOAD_ERROR_FLAG,
    payload: {
      uploadErrorFlag: state
    }
  });
};

export const checkForPhoto = photo => {
  if (photo == string.PHOTOS_KEY) {
    return true;
  }
  return false;
};

export const handleUploadSubmit = e => (dispatch, getState) => {
  dispatch(showLoadingIcon(true));
  e.preventDefault();
  const { upload } = getState().sideBar;
  const storeId = getState().modal.storeData.id;
  const { userPhotoUploadType } = getState().sideBar.uploadInfo;
  const userPhotoType = Object.keys(userPhotoUploadType);
  const isPhoto = checkForPhoto(userPhotoType[0]);

  const formData = new FormData();
  formData.append('user_photo[printable_image]', upload.file);
  formData.append(
    'user_photo[user_photo_type]',
    userPhotoUploadType[userPhotoType[0]]
  );
  if (getState().sideBar.isUploadLogo) {
    formData.append('user_photo[is_tiled]', true);
  } else {
    formData.append('user_photo[is_tiled]', false);
  }
  formData.append('user_photo[is_photo]', isPhoto);
  formData.append('store_id', storeId);

  const config = {
    onUploadProgress: progressEvent => {
      const totalLength = progressEvent.lengthComputable
        ? progressEvent.total
        : progressEvent.target.getResponseHeader('content-length') ||
          progressEvent.target.getResponseHeader(
            'x-decompressed-content-length'
          );
      const fileSizeInMB = totalLength / (1024 * 1024);
      dispatch({
        type: actions.SET_FILE_SIZE,
        payload: {
          fileSize: fileSizeInMB.toFixed(2)
        }
      });

      if (totalLength !== null) {
        const progressData = Math.round(
          (progressEvent.loaded * 100) / totalLength
        );
        dispatch(setFileUploadStatus(progressData));
      }
    }
  };

  api.sendUploadFile(formData, config).then(postResponse => {
    getResponse(
      api.getUploadedFile,
      postResponse.data.id,
      dispatch,
      getState,
      10000
    )
      .then(res => {
        uploadError(res, dispatch);
      })
      .catch(() => {
        dispatch(showLoadingIcon(false));
        dispatch(setLoadingState(null));
      });
  });
};

const uploadError = (res, dispatch) => {
  if (Object.keys(res).length == 0) {
    dispatch(showLoadingIcon(false));
    dispatch(setFileUploadStatus(null));
    dispatch(handleUploadErrorCase(Constants.PROCESSING_FAILED));
  } else if (
    res.result === Constants.ERROR ||
    res.result === Constants.FAILED
  ) {
    dispatch(showLoadingIcon(false));
    dispatch(setFileUploadStatus(null));
    if (res.reason === Constants.MULTIPAGE_PDF_NOT_SUPPORTED_TEXT) {
      dispatch(
        handleUploadErrorCase(Constants.MULTIPAGE_PDF_NOT_SUPPORTED_TEXT)
      );
    } else if (res.reason === Constants.ENCRYPTED_PDF_ERROR) {
      dispatch(handleUploadErrorCase(Constants.ENCRYPTED_PDF_ERROR));
    } else if (res.reason === Constants.OPEN_PDF_ERROR) {
      dispatch(handleUploadErrorCase(Constants.OPEN_PDF_ERROR));
    } else if (res.reason === Constants.UNSUPPORTED_FILE_TYPE_ERROR) {
      dispatch(handleUploadErrorCase(Constants.UNSUPPORTED_FILE_TYPE_ERROR));
    } else {
      dispatch(handleUploadErrorCase(Constants.PROCESSING_FAILED));
    }
  } else {
    dispatch(showLoadingIcon(false));
    dispatch(handleUploadDialogueState(false));
    dispatch(loadToUploadArray(res));
  }
};

export const saveDropBoxFile = files => dispatch => {
  dispatch(showDropboxUploadDialog(true));
  let array = [];
  if (!Array.isArray(files)) {
    array.push(files);
  } else {
    array = files;
  }
  dispatch({
    type: actions.SET_DROPBOX_FILES,
    payload: {
      dropboxfile: array
    }
  });
};

export const dropBoxSubmit = () => (dispatch, getState) => {
  dispatch(showLoadingIcon(true));
  const storeId = getState().modal.storeData.id;
  const files = getState().sideBar.dropboxfile;
  const fileIndex = getState().sideBar.dropboxFileIndex;

  const json = {
    name: files[fileIndex].name,
    user_photo_type: Constants.USER_PHOTO_ELEMENT_TYPE,
    path: files[fileIndex].link,
    file_size: files[fileIndex].bytes,
    is_tiled: false,
    store_id: storeId,
    media_id: files[fileIndex].id
  };
  api.importDropboxContent(json).then(postResponse => {
    getResponseForDropbox(
      api.getDropboxUploadedFile,
      postResponse.data.id,
      storeId
    )
      .then(res => {
        const previuosContents = getState().sideBar.dropBoxErrorDict.contents;
        if (
          Object.keys(res).length == 0 ||
          res.result === Constants.ERROR ||
          res.result === Constants.FAILED
        ) {
          let reason = '';

          if (res.reason === Constants.MULTIPAGE_PDF_NOT_SUPPORTED_TEXT) {
            reason = string.MULTIPAGE_PDF_NOT_SUPPORTED_TEXT;
          } else if (res.reason === Constants.ENCRYPTED_PDF_ERROR) {
            reason = string.ENCRYPTED_PDF_NOT_SUPPORTED_TEXT;
          } else if (res.reason === Constants.OPEN_PDF_ERROR) {
            reason = string.ERROR_IN_OPENING_PDF_FILE_TEXT;
          } else if (res.reason === Constants.UNSUPPORTED_FILE_TYPE_ERROR) {
            reason = string.INVALID_FILETYPE_ERROR_TEXT;
          } else {
            reason = string.PROCESSING_FAILED;
          }

          previuosContents.push({
            fileName: files[fileIndex].name,
            description: reason
          });

          if (fileIndex == files.length - 1) {
            const dict = {
              header: string.DROPBOX_IMPORT_ERROR_HEADER,
              contents: previuosContents
            };
            dispatch(setDropBoxErrorParams(dict));
          }
        } else {
          dispatch(loadToUploadArray(res));
        }
        if (fileIndex == files.length - 1) {
          // set flag for dropbox = false;
          dispatch(setDropboxFileIndex(0));
          dispatch(showDropboxUploadDialog(false));
          dispatch(showLoadingIcon(false));
          if (previuosContents.length > 0) {
            dispatch(setDropBoxErrorFlag(true));
          }
        } else {
          // increment fileindex;
          dispatch(setDropboxFileIndex(fileIndex + 1));
          dispatch(dropBoxSubmit());
        }
      })
      .catch(() => {
        dispatch(setLoadingState(null));
        dispatch(showLoadingIcon(false));
      });
  });
};

export const patternInfoClicked = item => (dispatch, getState) => {
  if (item && item.patternDesigner && item.patternDesigner.id) {
    api.getPatternInfo(item.patternDesigner.id).then(response => {
      const info = response.data.designer;
      item.patternDesigner.profileImageURL = info.profileImage;
      item.patternDesigner.country = info.country.name;
      dispatch(triggerRedrawAfterDataFetch());
    });
  } else if (item.imageSource == Constants.DREAMSTIME_IMAGE_SOURCE) {
    const storeId = getState().modal.storeData.id;
    const isVanilla = getState().modal.envData.is_vanilla_designer;
    const basePrice = getState().modal.storeData.basePricePerDreamstimeImage;
    let cost = 1;
    api.getDreamstimeInfo(item.mediaId, storeId).then(response => {
      const info = response.data.Image;

      cost = dispatch(
        setDreamstimePriceDetails(
          item,
          response.data.Prices,
          isVanilla,
          basePrice
        )
      );
      item.costValue = cost;
      item.author = info.Author;
      item.keywords = info.Keywords;
      item.description = info.Description;
      item.downloads = info.Downloads;
      item.views = info.Views;
      item.profileImageURL = info.ThumbnailUrl;
      item.profileURL = info.AuthorUrl;
      item.detailsUrl = info.DetailUrl;
      dispatch(triggerRedrawAfterDataFetch());
    });
  } else if (item && item.type === Constants.SCENE_KEY) {
    if (item.detailsUrl == undefined) {
      item.costValue = null;
      item.author = Constants.PATTERN_AUTHOR;
      item.country = Constants.PATTERN_COUNTRY;
      item.keywords = null;
      item.description = Constants.PATTERN_DESCRIPTION;
      item.profileImageURL = Icons.martina;
      item.profileURL = Constants.PATTERN_PROFILE_URL;
      item.detailsUrl = `https://www.patterndesigns.com/en/design/${item.external_id}/${item.name}`;
    }
    dispatch(triggerRedrawAfterDataFetch());
  }
};

export const viewPriceClicked = item => () => {
  api.getFololiaPurchaseDetails(item.id).then(() => {});
};

const getCategory = category => {
  if (
    category === Constants.NEW_POSTER_CATEGORY ||
    category === Constants.POSTER_CATEGORY
  ) {
    return Constants.POSTER_CATEGORY;
  }
  if (category === Constants.GIFTWRAPS_CATEGORY) {
    return Constants.GIFTWRAPS_CATEGORY;
  }
  if (isMaskApp(category)) {
    return Constants.FACEMASK_CATEGORY;
  }
  return Constants.WALLPAPER_CATEGORY;
};

export const patternDesignCost = item => (dispatch, getState) => {
  if (item.type === Constants.USER_PHOTO_TYPE) {
    if (item.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
      let { category } = getState().modal.envData;
      if (isSignageSuiteProduct()) {
        category = getState().home.selectedProduct.groupType;
      }
      const priceCategory = getCategory(category);
      const patternCostDetails = getState().sideBar.pattrenDesignCost;
      const storeId = getState().modal.storeData.id;

      if (patternCostDetails.price) {
        item.costValue = patternCostDetails.price;
        item.costCurrency = patternCostDetails.currency;
        item.currencySymbol = patternCostDetails.currencySymbol;
      } else {
        dispatch(handleBottomBarClick(true));
        api.getPatternDesignCost(storeId).then(response => {
          const price =
            response.data.price.cost_of_products.prices[priceCategory].amount;
          const { currency } = response.data.price.cost_of_products.prices[
            priceCategory
          ];
          const currencySymbol =
            response.data.price.cost_of_products.prices[priceCategory].symbol;
          dispatch({
            type: actions.PATTERN_DESIGN_COST,
            payload: {
              cost: price,
              currency,
              currencySymbol
            }
          });
          item.costValue =
            response.data.price.cost_of_products.prices[priceCategory].amount;
          item.costCurrency =
            response.data.price.cost_of_products.prices[priceCategory].currency;
          item.currencySymbol =
            response.data.price.cost_of_products.prices[priceCategory].symbol;

          dispatch(triggerRedrawAfterDataFetch());
          dispatch(handleBottomBarClick(false));
        });
      }
    }
  }
};

export const loadToUploadArray = inRes => (dispatch, getState) => {
  const res = inRes;
  res.theme_id = getState().modal.startUpScene.themeId;
  res.theme_name = getState().modal.startUpScene.themeName;
  const contents = getState().sideBar.uploadInfo.uploadArray;
  const uploadObj = createResponseObject(
    [res],
    Constants.USER_PHOTO_TYPE,
    res.image_source
  )[0];
  contents.push(uploadObj);
  dispatch({
    type: actions.SET_UPLOAD_CONTENTS,
    payload: {
      uploadArray: contents
    }
  });
};

export const setUserPhotoUploadType = (name, type) => dispatch => {
  const dict = {};
  dict[name] = type;

  dispatch({
    type: actions.SET_UPLOAD_USER_PHOTO_TYPE,
    payload: {
      userPhotoUploadType: dict
    }
  });
};

const getResponse = async (func, id, dispatch, getState, time) => {
  let retries = 50;
  let success = false;
  let failed = false;
  const storeId = getState().modal.storeData.id;
  let data = {};
  async function getText() {
    func(id, storeId).then(res => {
      if (res.data.result === 'SUCCESS') {
        success = true;
        data = res.data;
      } else if (
        res.data.result === Constants.FAILED ||
        res.data.result === Constants.ERROR
      ) {
        failed = true;
        data = res.data;
      }
    });
  }
  while (retries-- > 0 && !success && !failed) {
    getText();
    await new Promise(resolve => setTimeout(resolve, time));
  }
  return data;
};

const getResponseForDropbox = async (func, id, storeId) => {
  let retries = 50;
  let success = false;
  let failed = false;
  let data = {};
  async function getDropbox() {
    func(id, storeId).then(res => {
      if (res.data.result === 'SUCCESS') {
        success = true;
        data = res.data;
      } else if (
        res.data.result === Constants.FAILED ||
        res.data.result === Constants.ERROR
      ) {
        failed = true;
        data = res.data;
      }
    });
  }
  while (retries-- > 0 && !success && !failed) {
    getDropbox();
    await new Promise(resolve => setTimeout(resolve, 2000));
  }
  return data;
};

export const handleUploadDialogueState = showDialoge => dispatch => {
  if (showDialoge) {
    dispatch(setSidebarVisibility(false));
  }
  dispatch({
    type: actions.SET_UPLOAD_FILE_STATUS,
    payload: {
      uploadDialogue: showDialoge
    }
  });
};

export const setFileUploadStatus = status => dispatch => {
  dispatch({
    type: actions.SET_UPLOAD_FILE_PERCENTAGE,
    payload: {
      uploadStatus: status
    }
  });
};

export const setSearchTags = (color, text, page) => (dispatch, getState) => {
  const theme = getState().sideBar.folderListElements;
  const offset = page * Constants.PATTERN_COUNT;
  let colored = color;
  let searchText = text;

  dispatch(setOldSearchTags(color, text));
  if (theme != null) {
    if (searchText === 'clear') {
      searchText = null;
      colored = null;

      if (theme.name === Constants.UNSPLASH) {
        dispatch(fetchUnsplashContents(theme));
      } else if (theme.name === Constants.GETTY_IMAGE) {
        dispatch(fetchGettyImageContents(theme));
      } else if (theme.name === Constants.I_STOCK) {
        dispatch(fetchIStockContents(theme));
      } else if (theme.name === Constants.DREAMSTIME) {
        dispatch(fetchDreamstimeContents(theme));
      } else if (theme.name === Constants.ADOBE_STOCK) {
        dispatch(fetchAdobeStockContents(theme));
      } else if (theme.name === Constants.HP_MOSAIC) {
        dispatch(fetchHPMosaicContents(theme, 1));
      } else if (
        (color != null || getState().sideBar.shouldLoadMoreContents) &&
        color != 'clear'
      ) {
        handlePatternSearchCategory(
          theme,
          color,
          searchText,
          offset,
          dispatch,
          getState
        );
      }
    } else {
      const pageIndex = page + 1;
      if (pageIndex === 1) {
        dispatch(setLoadingState(string.LOADING_KEY));
      }
      if (theme.name === Constants.UNSPLASH) {
        handleUnsplashSearchCategory(
          theme,
          text,
          pageIndex,
          dispatch,
          getState
        );
      } else if (theme.name === Constants.DREAMSTIME) {
        handleDreamstimeSearchCategory(
          theme,
          text,
          pageIndex,
          dispatch,
          getState
        );
      } else if (theme.name === Constants.GETTY_IMAGE) {
        handleGettyImageSearchCategory(
          theme,
          text,
          pageIndex,
          dispatch,
          getState
        );
      } else if (theme.name === Constants.I_STOCK) {
        handleIStockSearchCategory(theme, text, pageIndex, dispatch, getState);
      } else if (theme.name === Constants.ADOBE_STOCK) {
        handleAdobeStockCategory(theme, text, pageIndex, dispatch, getState);
      } else if (theme.name === Constants.HP_MOSAIC) {
        dispatch(fetchHPMosaicContents(theme, pageIndex));
      } else {
        // PatternSearch
        handlePatternSearchCategory(
          theme,
          colored,
          searchText,
          offset,
          dispatch,
          getState
        );
      }
    }
  }
  dispatch({
    type: actions.SET_SEARCH_TAGS,
    payload: {
      updatedPatternColor: colored,
      updatedText: searchText,
      updatedPage: page
    }
  });
};

export const setOldSearchTags = (color, text) => dispatch => {
  dispatch({
    type: actions.SET_OLD_SEARCH_TAGS,
    payload: {
      previousPatternColor: color,
      previousText: text
    }
  });
};

export const handleUnsplashSearchCategory = (
  theme,
  text,
  page,
  dispatch,
  getState
) => {
  searchForUnsplash(theme, text, 30, page, dispatch, getState);
};

export const handleGettyImageSearchCategory = (
  theme,
  text,
  page,
  dispatch,
  getState
) => {
  searchForGettyImage(theme, text, 30, page, dispatch, getState);
};

export const handleIStockSearchCategory = (
  theme,
  text,
  page,
  dispatch,
  getState
) => {
  searchForIStock(theme, text, 30, page, dispatch, getState);
};

export const handleAdobeStockCategory = (
  theme,
  text,
  page,
  dispatch,
  getState
) => {
  searchForAdobeStock(theme, text, page, dispatch, getState);
};

export const handlePatternSearchCategory = (
  theme,
  color,
  text,
  offset,
  dispatch,
  getState
) => {
  if (offset === 0) {
    dispatch(setLoadingState(string.LOADING_KEY));
  }
  if (color || text) {
    searchForPatterns(theme, null, color, text, offset, dispatch, getState);
  } else {
    searchForPatterns(theme, theme.id, color, text, offset, dispatch, getState);
  }
};

export const handleDreamstimeSearchCategory = (
  theme,
  text,
  page,
  dispatch,
  getState
) => {
  searchForDreamstime(theme, text, page, dispatch, getState);
};

export const handleHPMosaicCategory = theme => (dispatch, getState) => {
  randomizeHPMosaicContents(
    theme,
    getState().sideBar.searchTags.updatedPage,
    dispatch,
    getState
  );
};

export const showDropboxUploadDialog = condition => dispatch => {
  dispatch({
    type: actions.SET_DROPBOX_UPLOAD_DIALOG,
    payload: {
      dropboxUploadDialog: condition
    }
  });
};

export const showLoadingIcon = condition => dispatch => {
  dispatch({
    type: actions.SHOW_LOADING_ICON,
    payload: condition
  });
};

export const setIsUploadLogo = condition => dispatch => {
  dispatch({
    type: actions.SET_IS_UPLOAD_LOGO,
    payload: {
      isUploadLogo: condition
    }
  });
};

export const clearDesign = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  wallCanvas.forEachObject(object => {
    dispatch(deleteElement(object));
  });
  if (getState().sideBar.documentColors.length > 0) {
    dispatch(clearDocumentColors());
  }
  wallCanvas.renderAll();
  getState().fabricCanvas.undoInstance.clear();
  getState().finalCheck.project.locked = false;
  getState().finalCheck.project.parentId = null;
};

export const clearDocumentColors = () => dispatch => {
  dispatch({
    type: actions.SET_DOCUMENT_COLORS,
    payload: {
      documentColors: []
    }
  });
};

export const getTextFonts = textPlaceables => (dispatch, getState) => {
  const defaultFonts = getState().modal.textFonts;
  const uniqueFontList = [];
  const inspirationFont = [];

  if (textPlaceables.length > 0) {
    for (let j = 0; j < textPlaceables.length; j++) {
      inspirationFont.push(textPlaceables[j].fontId);
    }

    api
      .getTextFontsInsp(inspirationFont)
      .then(respone => {
        const fontsList = respone.data;
        for (let j = 0; j < fontsList.length; j++) {
          uniqueFontList.push(fontsList[j]);
        }

        for (let m = uniqueFontList.length - 1; m >= 0; m--) {
          for (let n = 0; n < defaultFonts.length; n++) {
            if (
              uniqueFontList[m].font_family === defaultFonts[n].font_family &&
              uniqueFontList[m].name === defaultFonts[n].name
            ) {
              uniqueFontList.splice(m, 1);
              break;
            }
          }
        }

        uniqueFontList.concat(defaultFonts);

        for (let k = 0; k < uniqueFontList.length; k++) {
          defaultFonts.push(uniqueFontList[k]);
        }

        dispatch({
          type: actions.SET_INSPIRATION_FONTS,
          payload: {
            inspirationFonts: fontsList
          }
        });
        dispatch({
          type: actions.UPDATE_WITH_INSPIRATION_FONTS,
          payload: {
            textFonts: defaultFonts
          }
        });
      })
      .catch(() => {});
  }
};

export const getDreamstimePrice = placeable => (dispatch, getState) => {
  if (
    placeable.type === Constants.USER_PHOTO_TYPE &&
    placeable.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE
  ) {
    const isVanilla = getState().modal.envData.is_vanilla_designer;
    const basePrice = getState().modal.storeData.basePricePerDreamstimeImage;
    let cost = 1;

    const storeId = getState().modal.storeData.id;
    api
      .getContentDetailForDreamstime(placeable.mediaId, storeId)
      .then(res => {
        cost = dispatch(
          setDreamstimePriceDetails(
            placeable,
            res.data.Prices,
            isVanilla,
            basePrice
          )
        );
        placeable.costValue = cost;
        dispatch(triggerRedrawAfterDataFetch());
      })
      .catch(() => {});
  }
};

export const setDreamstimePriceDetails = (
  element,
  priceList,
  isVanilla,
  basePrice
) => () => {
  let cost = 1;

  const RFLicenceList = priceList.filter(
    price => price.License == Constants.RF_LICENCE
  );
  const validSize = RFLicenceList.filter(
    size => size.Size == Constants.DEFAULT_LICENCE_SIZE
  );
  const validSizeForX = checkForValidSizeAccountForDreamstime(validSize);

  if (validSizeForX.cost > 0) {
    cost = validSizeForX.cost;
  }

  if (isVanilla) {
    return cost;
  }
  return cost + basePrice;
};

export const checkForValidSizeAccountForDreamstime = size => {
  let price = 0;
  let accountType = '';

  if (size[0].Price > 0) {
    price = size[0].Price;
    accountType = size[0].PriceUnit;
  } else {
    // zero case
  }
  return {
    cost: price,
    type: accountType
  };
};

export const setDropboxFileIndex = index => dispatch => {
  dispatch({
    type: actions.SET_DROPBOX_FILE_INDEX,
    payload: {
      dropboxFileIndex: index
    }
  });
};

export const instagramUploadIsClicked = () => (dispatch, getState) => {
  const { instagramLoginFlag } = getState().sideBar;

  if (instagramLoginFlag) {
    // user is logged in, just display items
    dispatch(addInstagramContents());
  } else {
    const child = window.open(
      '/instagram/connect?source=web',
      '',
      'width=560,height=340,toolbar=0,menubar=0,location=0'
    );
    setTimeout(() => {
      child.focus();
    }, 1000);
  }
};

export const addInstagramContents = () => dispatch => {
  dispatch(setLoadingState(string.LOADING_KEY));
  dispatch(setInstagramLoginFlag(true));
  dispatch(fetchInstagramContents(null));
};

export const fetchInstagramContents = nextURL => (dispatch, getState) => {
  api
    .fetchInstagramContents(nextURL)
    .then(response => {
      if (response.status == 200) {
        const dataJson = response.data;
        if (dataJson.result == 'Success') {
          dispatch(setInstagramContents(dataJson.data));
        }
      }
    })
    .catch(() => {
      const count = getState().sideBar.instagramRetryCount;
      if (count < 1) {
        dispatch({
          type: actions.SET_INSTAGRAM_RETRY_COUNT,
          payload: {
            instagramRetryCount: count + 1
          }
        });
        dispatch(setInstagramLoginFlag(false));
        dispatch(instagramUploadIsClicked());
      } else {
        dispatch(setLoadingState(null));
        const dict = {
          header: string.INSTAGRAM_KEY,
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      }
    });
};

export const setInstagramContents = dataJson => (dispatch, getState) => {
  let instagramArray = createResponseObject(
    dataJson.data,
    Constants.USER_PHOTO_TYPE,
    Constants.INSTAGRAM_IMAGE_SOURCE
  );
  instagramArray.forEach(instagramEle => {
    instagramEle.themeId = getState().modal.startUpScene.themeId;
    instagramEle.themeName = getState().modal.startUpScene.themeName;
  });
  const tempArray = getState().sideBar.instagramData;
  instagramArray = instagramArray.concat(tempArray);
  dispatch(setInstagramNextURL(dataJson.paging.next));
  dispatch({
    type: actions.SET_INSTAGRAM_CONTENTS,
    payload: {
      instagramData: instagramArray
    }
  });
  dispatch(setLoadingState(null));
};

export const setInstagramNextURL = nextURL => dispatch => {
  dispatch({
    type: actions.SET_INSTAGRAM_NEXT_URL,
    payload: {
      instagramElementsNextURL: nextURL
    }
  });
};

export const showNextInstagramList = () => (dispatch, getState) => {
  const nextURL = getState().sideBar.instagramElementsNextURL;
  if (nextURL !== null) {
    dispatch(fetchInstagramContents(nextURL));
  }
};

export const setInstagramUploadData = () => (dispatch, getState) => {
  const uploadList = [];
  const { project } = getState().finalCheck;
  const instagramPlacings = getOnlyInstagramPlacings(getPlacings(project));

  for (let p = 0; p < instagramPlacings.length; p++) {
    if (!instagramPlacings[p].placeableId) {
      uploadList.push({
        id: instagramPlacings[p].placeable.mediaId,
        url: instagramPlacings[p].placeable.imagePath,
        user_photo_type: instagramPlacings[p].placeable.userPhotoType
      });
    }
  }

  return {
    upload: uploadList,
    instaPlacings: instagramPlacings
  };
};

export const importFromInstagram = () => (dispatch, getState) => {
  dispatch(setLoadingState(string.IMPORTING_KEY));
  const storeId = getState().modal.storeData.id;
  const uploadParams = dispatch(setInstagramUploadData());
  const uploadBody = uploadParams.upload;

  if (uploadBody.length > 0) {
    return new Promise(resolve => {
      uploadFile(
        uploadBody,
        storeId,
        uploadParams.instaPlacings,
        dispatch
      ).then(resolve);
    });
  }
  // proceed to save
  dispatch(setLoadingState(null));
  return Promise.resolve();
};

export const uploadFile = (array, id, placings, dispatch) => {
  const promiseObj = new Promise(resolve => {
    const jsonString = JSON.stringify({
      media_details: array,
      image_source: Constants.INSTAGRAM_IMAGE_SOURCE,
      store_id: id
    });
    api.importInstagramContent(jsonString).then(postResponse => {
      const userPhotoIdsArray = [];
      if (postResponse.status == 200) {
        const uploadDataJson = postResponse.data;
        let mediaJavaArray;
        if (uploadDataJson.result == 'SUCCESS') {
          mediaJavaArray = uploadDataJson.media_details;
        }
        if (mediaJavaArray) {
          for (let i = 0; i < mediaJavaArray.length; i++) {
            const mediaDict = mediaJavaArray[i];
            const mId = Object.keys(mediaDict)[0];
            userPhotoIdsArray.push(mId);
          }

          // loading dialogue to importing

          getResponseForDropbox(
            api.getInstagramUploadedFile,
            userPhotoIdsArray,
            id
          )
            .then(res => {
              dispatch(setLoadingState(null));
              updatePlaceable(res.user_photos, placings);
              resolve();
            })
            .catch(() => {
              dispatch(setLoadingState(null));
              dispatch(showLoadingIcon(false));
            });
        }
      }
    });
  });
  return promiseObj;
};

export const updatePlaceable = (responseData, sourcePlacings) => {
  const userPhotoData = createResponseObject(
    responseData,
    Constants.USER_PHOTO_TYPE,
    Constants.USER_PHOTO_ELEMENT_TYPE
  );
  sourcePlacings.forEach(placing => {
    const matchedUserPhotos = userPhotoData.filter(
      data => data.mediaId == placing.placeable.mediaId
    );
    if (matchedUserPhotos.length > 0) {
      const [matchedUserPhoto] = matchedUserPhotos;
      placeableIsUpdated(placing, matchedUserPhoto);
    }
  });
};

export const setInstagramLoginFlag = flag => dispatch => {
  dispatch({
    type: actions.SET_INSTAGRAM_LOGIN_FLAG,
    payload: {
      instagramLoginFlag: flag
    }
  });
};

export const setLoaderCoordinates = e => dispatch => {
  dispatch({
    type: actions.SET_LOADER_COORDINATES,
    payload: {
      loaderCoordinates: e
    }
  });
};
export const setDropBoxErrorParams = dict => dispatch => {
  dispatch({
    type: actions.DROPBOX_ERROR_PARAMS,
    payload: {
      dropBoxErrorDict: dict
    }
  });
};

export const setDropBoxErrorFlag = flag => dispatch => {
  dispatch({
    type: actions.DROPBOX_ERROR_FLAG,
    payload: {
      dropBoxErrorFlag: flag
    }
  });
};

// function getBase64(file, cb) {
//   let reader = new FileReader();
//   reader.readAsDataURL(file);
//   reader.onload = function() {
//     cb(reader.result);
//   };
//   reader.onerror = function(error) {
//     console.log('Error: ', error);
//   };
// }

export const unlockFolderRequest = (
  password,
  storeId,
  item,
  isSubtheme,
  authenticationWindowHandler,
  handleErrorMessage
) => dispatch => {
  const requestData = JSON.stringify({
    password,
    store_id: storeId
  });

  api
    .authenticateContentFolder(requestData, item.id)
    .then(response => {
      if (response.status === 200) {
        if (response.data.result === 'SUCCESS') {
          item.needsAuthenetication = false;
          authenticationWindowHandler(false);
          handleErrorMessage(false);
          if (!isSubtheme) {
            dispatch(getFolderListElements(item));
          }
        } else {
          handleErrorMessage(true);
        }
      }
    })
    .catch(() => {});
};

export const setTabUsageDuration = (time, tab) => dispatch => {
  dispatch({
    type: actions.TAB_USAGE_DURATION,
    payload: {
      tabTime: time,
      tabName: tab
    }
  });
};

export const getSelectedFont = fontId => (dispatch, getState) => {
  const { textFonts, inspirationFonts } = getState().modal;
  let selectedFont;
  let matchedFonts = textFonts.filter(
    f => f.font_family === Constants.DEFAULT_FONT
  );
  if (matchedFonts.length > 0) {
    [selectedFont] = matchedFonts;
  } else {
    [selectedFont] = textFonts;
  }

  if (fontId) {
    matchedFonts = textFonts.filter(f => f.id === fontId);
    if (matchedFonts.length === 0 && inspirationFonts) {
      const matchedInspirationFonts = inspirationFonts.filter(
        f => f.id === fontId
      );
      if (matchedInspirationFonts.length > 0) {
        const [inspirationFont] = matchedInspirationFonts;
        [selectedFont] = textFonts.filter(
          textFont =>
            textFont.font_family === inspirationFont.font_family &&
            textFont.name === inspirationFont.name
        );
      }
    } else {
      [selectedFont] = matchedFonts;
    }
  }
  return selectedFont;
};

export const setSolidBackgroundColor = color => dispatch => {
  dispatch({
    type: actions.SET_SOLID_BACKGROUND_COLOR,
    payload: {
      solidBackgroundColor: color
    }
  });
};

export const canShowMyRoomTab = () => (dispatch, getState) =>
  isWallcoveringApp(getState().modal.envData.category) ||
  (dispatch(checkIfCanvasApp()) &&
    getState().modal.storeData.supportsRoomLayout);

export const canShowTemplatesTab = () => (dispatch, getState) => {
  const { envData, storeData } = getState().modal;
  return (
    envData.category ===
      (Constants.NEW_POSTER_CATEGORY || Constants.COMMERCIAL_POSTER_CATEGORY) &&
    (envData.is_vanilla_designer ||
      storeData.templatePreference.toLowerCase() != 'none')
  );
};

export const templatesTabItemIsSelected = tabId => (dispatch, getState) => {
  dispatch({
    type: actions.CHANGE_TEMPLATES_TAB,
    payload: {
      activeTemplatesTab: Constants.inspirationsTab
    }
  });
  let category = Constants.allInspirationCategory;
  if (tabId != Constants.inspirationsTab) {
    const covidInspirations = getState().sideBar.inspirationCategory.filter(
      inspirationFilter =>
        inspirationFilter.category === Constants.covidInspirationCategory
    );
    if (
      covidInspirations.length > 0 &&
      getState().sideBar.inspirations.category !=
        Constants.covidInspirationCategory
    ) {
      category = Constants.covidInspirationCategory;
    }
  }
  dispatch(loadInspirations(10, { value: category }, () => {}));
};

export const shouldHideSidebarInDesktopMode = () => (dispatch, getState) => {
  const { envData } = getState().modal;
  return (
    (envData && envData.view_only_preview_mode) ||
    dispatch(isVisualizeModeActive())
  );
};

export const generateAI = prompt => (dispatch, getState) => {
  const storeId = getState().modal.storeData.id;
  return new Promise(resolve => {
    api
      .generateAiImage(storeId, prompt)
      .then(res => {
        resolve(res);
      })
      .catch(() => {});
  });
};

export const importFromOpenAI = aiImage => (dispatch, getState) => {
  dispatch(setLoadingState(string.LOADING_KEY));
  const storeId = getState().modal.storeData.id;
  const formData = new FormData();
  formData.append('path', aiImage.imagePath);
  formData.append('user_photo_type', aiImage.userPhotoType);
  formData.append('name', aiImage.fileName);
  formData.append('file_size', aiImage.fileSize);
  formData.append('store_id', storeId);

  api
    .importFromAI(formData)
    .then(response => {
      getResponse(
        api.getUploadedFile,
        response.data.id,
        dispatch,
        getState,
        10000
      )
        .then(res => {
          res.theme_id = getState().modal.startUpScene.themeId;
          res.theme_name = getState().modal.startUpScene.themeName;

          const responeObj = createResponseObject(
            [res],
            Constants.USER_PHOTO_TYPE,
            res.image_source
          )[0];

          dispatch(addToCanvas(responeObj));
          dispatch(setLoadingState(null));
        })
        .catch(() => {
          dispatch(setLoadingState(null));
        });
    })
    .catch(() => {
      dispatch(setLoadingState(null));
    });
};
